"use client";

import Link from "next/link";
import Button from "@/components/static/Button";
import Image from "next/image";
import parse from "html-react-parser";
import { useState } from "react";
import { OptionsProps } from "@/lib/types";
import { languages } from "@/i18n/config";
import { cn } from "@/lib/utils";
import IconArrowRight from "@/icons/ArrowRight";
import Globe from "@/icons/Globe";

export default function Inner({
    footerMenus,
    footerMetaMenu,
    options,
    translations,
    locale,
}: {
    footerMenus: any;
    footerMetaMenu: any;
    options: OptionsProps;
    translations: { de: string; en: string; fr: string };
    locale: string;
}) {
    const [langOpen, setLangOpen] = useState(false);

    return (
        <footer className='bg-brand-light text-white text-base overflow-hidden py-12 md:py-20'>
            <div className='container relative'>
                <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-[minmax(0,_1fr)_36%_minmax(0,_2fr)] gap-16'>
                    <div>
                        <Image
                            src={options.logo.url}
                            height={options.logo.height}
                            width={options.logo.width}
                            alt={options.logo.alt}
                        />
                        <div className='mt-4 text-md lg:text-sm'>{parse(options.contact)}</div>
                    </div>
                    {footerMenus?.map((footerMenu: any, index: number) => {
                        return (
                            <div key={index}>
                                {footerMenu.menu != false && (
                                    <nav className='flex flex-col gap-4'>
                                        <ul className='flex flex-col'>
                                            {footerMenu.menu_items?.map(
                                                (menuItem: any, index: number) => {
                                                    return (
                                                        <li key={index}>
                                                            <Link
                                                                href={menuItem?.url || "#"}
                                                                className='flex items-center text-h2 md:text-h4 py-2 group transition'
                                                            >
                                                                <IconArrowRight className='size-10 text-white w-0 opacity-0 overflow-hidden group-hover:w-6 group-hover:opacity-100 transition-all duration-300 ease-in-out' />
                                                                <span>{menuItem?.title}</span>
                                                            </Link>
                                                        </li>
                                                    );
                                                }
                                            )}
                                        </ul>
                                    </nav>
                                )}
                            </div>
                        );
                    })}
                    <div className='flex flex-col lg:items-end gap-6 text-md xl:pl-36'>
                        <span className='text-lg lg:text-right lg:max-w-[200px]'>
                            {parse(options.contact_cta ?? "")}
                        </span>
                        <div>
                            <Button
                                as='link'
                                href={options.contact_cta_button.url}
                                type='white'
                                className='inline-flex'
                            >
                                {options.contact_cta_button.title}
                            </Button>
                        </div>
                    </div>
                </div>
                {/* <nav className='flex flex-wrap justify-start lg:justify-end mt-6'> */}
                <nav className='flex flex-wrap justify-between mt-6'>
                    <div className='relative'>
                        <button
                            className={cn(
                                "flex items-center gap-x-2"
                                // headerPos >= scrollDistance && "text-black"
                            )}
                            onClick={() => {
                                setLangOpen(!langOpen);
                            }}
                        >
                            <div className='rounded-full overflow-hidden'>
                                <Globe className='text-transparent' />
                            </div>
                            {languages.find((lang) => lang.locale === locale)?.name || ""}
                        </button>
                        {langOpen && (
                            <div className='absolute bottom-full mb-3 left-0 bg-[#EAECEF] text-black rounded-lg overflow-hidden mt-3'>
                                <ul>
                                    {languages.map((language, index) => {
                                        return (
                                            <li key={index}>
                                                <Link
                                                    lang={language.locale}
                                                    href={
                                                        translations[
                                                            language.locale as keyof typeof translations
                                                        ]
                                                    }
                                                    className='p-4 block leading-none hover:bg-black/10'
                                                >
                                                    {language.name}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                    </div>
                    <ul className='flex lg:justify-end flex-row gap-x-2'>
                        {footerMetaMenu?.menu_items?.map((menuItem: any, index: number) => {
                            return (
                                <li key={index}>
                                    <Link
                                        href={menuItem?.url || "#"}
                                        className='flex items-center gap-2 text-sm underline group transition'
                                    >
                                        <span>{menuItem?.title}</span>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </footer>
    );
}
